class LazyYoutubeVideos
{
    static load() {
        Array.from(document.querySelectorAll('[data-content="youtube-video"]')).forEach((element) => {
            let embedUrl = element.getAttribute('data-embed'),
                imageElement = new Image();

            imageElement.src = 'https://i.ytimg.com/vi/' + embedUrl + '/hqdefault.jpg';
            imageElement.setAttribute('alt', 'Youtube Video');
            imageElement.addEventListener('load', () => element.appendChild(imageElement));

            element.addEventListener('click', () => {
                let iframeElement = document.createElement('iframe');

                iframeElement.setAttribute('frameborder', '0');
                iframeElement.setAttribute('allowfullscreen', '');
                iframeElement.setAttribute('src', 'https://www.youtube.com/embed/' + embedUrl + '?rel=0&showinfo=0&autoplay=1');

                element.innerHTML = '';
                element.appendChild(iframeElement);
            });
        });
    }
}

export {LazyYoutubeVideos};
